<template>
  <div class="text-left">
    <form>
      <MoleculesFormsValidatedField type="email" autocomplete="username" v-model="email" :label="i18n.t('Zadejte Váš e-mail')" :show-error-only="true" :required="true" :placeholder='i18n.t(`Například "jan.novak(at)gmail.com"`)' :error-message="i18n.t('Zadejte e-mail ve správném formátu')" />
      <MoleculesFormsValidatedField v-if="!forgottenShown" type="password" autocomplete="current-password" v-model="password" :show-error-only="true" :required="true" :label="i18n.t('Heslo')" :placeholder="i18n.t('Zadejte Vaše heslo')" @submit="login" />
      <AtomsFormsCheckbox v-model="forgottenShown" :label="i18n.t('Nevím svoje heslo')" />
      <div v-if="!forgottenShown" class="mt-6 text-right desktop:mt-0">
        <MoleculesButtonsButton :arrow-right="true" @click="login">{{ $t('Přihlásit se') }}</MoleculesButtonsButton>
      </div>
      <div v-if="forgottenShown">
        <div class="my-6">{{ $t('Zadejte e-mailovou adresu vyplněnou při registraci. Vygenerujeme pro Vás nové heslo a pošleme na uvedenou adresu.') }}</div>
        <div class="text-right">
          <MoleculesButtonsButton :arrow-right="true" @click="sendForgotten">{{ $t('Obnovit heslo') }}</MoleculesButtonsButton>
        </div>
      </div>
    </form>
  </div>
</template>
<script setup>

const i18n = useI18n();
const locale = useLocale().getLocale();

const email = ref('');
const password = ref('');
const forgottenShown = ref(false);

const emit = defineEmits(['logged']);

const login = async () => {
  if (await useCustomer().login(email.value, password.value)) {
    useMessage().show(i18n.t('Přihlášení úspěšné'));
    useBaseAnalytics().push({ user_email: email.value })
    useBaseAnalytics().pushEvent('login');
    emit('logged');
  }
  else {
    useMessage().show(i18n.t('Nesprávné přihlašovací údaje'), null, true);
  }
}

const sendForgotten = async () => {
  if (!email.value) {
    useMessage().show(i18n.t('Zadejte e-mailovou adresu'), null, true);
  }
  else {
    await useApiFetch(`/api/forgottenPassword?email=${encodeURIComponent(email.value)}&languageId=${locale.languageId}`);
    useMessage().show(i18n.t('Zapomenuté heslo bylo odesláno na uvedený e-mail'));
    forgottenShown.value = false;

    useBaseAnalytics().pushEvent('user_interaction', {
      interaction_name: 'forgotten_password'
    });
  }
}

</script>